import React, { useContext, useEffect, useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Toolbar, Grid, Snackbar, CircularProgress } from '@material-ui/core/';
import { BookmarkBorderOutlined } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import logo from '../assets/img/logo.png'
import FormUser from './FormUser';
import Modal from './Modal';
import { liquidationReducer } from '../reducers/liquidationReducer';
import FormLiquidation from './FormLiquidation';
import bg from '../assets/img/bg.png';
import '../css/main.css';
import HeaderModules from './HeaderModules';
import { fb } from '../utils/Firebase';
import { LoadingContext } from '../context/Loading';
import { comercianteReducer, iState } from '../reducers/comercianteReducer';

const initialState = [];

const Main = () => {

    const classes = useStyles();
    const [visibleModal, setVisibleModal] = useState(false);
    const [snackbar, setSnackbar] = useState({ visible: false, message: '' });
    const [services, setServices] = useState({
        form: {
            name: 'formulario de renovación',
            value: 6500
        }
    })
    const [affiliation, setAffiliation] = useState('');
    const [configuraciones, setConfiguraciones] = useState({
        design: {},
        video: {},
        listas: []
    });

    const { isReady, setIsReady } = useContext(LoadingContext);
    const [state, dispatch] = useReducer(liquidationReducer, initialState);
    const [comerciante, setComerciante] = useReducer(comercianteReducer, iState);
    

    useEffect(() => {
        let subscribed = true;
    
        if(subscribed) {
            (async () => {
                const response = await fb.firestore().collection('configuraciones').get();
                setConfiguraciones({
                    design: response.docs[0].data(),
                    video: response.docs[1].data().video,
                    listas: response.docs[1].data().listas
                });
                setIsReady(true);
            })();
        }
       
        return () => subscribed = false;
    }, []);

    const numberFormat = number => {
        return new Intl.NumberFormat("es-CO", { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(number);
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexFlow: 'column', justifyContent: 'space-between' }}> 
            <AppBar position="fixed" color='#fff'>
                <Toolbar>
                    <div style={{ width: 50, height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {
                            isReady && <img src={configuraciones?.design?.logo ? configuraciones?.design?.logo : 'https://latarta.com.co/wp-content/uploads/2018/06/default-placeholder.png'} alt='' width={50} />
                        }
                    </div>
                    
                </Toolbar>
            </AppBar>
            
          
            <Grid container style={{ marginTop: 60, paddingLeft: 10, paddingRight: 10 }}>
                <Grid item xs={12}>
                    <HeaderModules
                        icon={<BookmarkBorderOutlined htmlColor='rgba(0,0,0,.7)' />}
                        title={`Liquidador de renovación año ${new Date().getFullYear()}`}
                        margin={10}
                    />
                </Grid>

                <Grid item xs={12} style={{ background: '#ffffff', paddingTop: 10, borderRadius: 6, marginBottom: 10 }}>
                    <div className={classes.containerForm}>
                        {
                            Object.values(comerciante.consultarExpediente).length <= 0
                                ? <FormUser
                                    setComerciante={setComerciante}
                                    setSnackbar={setSnackbar}
                                />
                                : (
                                    <FormLiquidation
                                        comerciante={comerciante}
                                        setComerciante={setComerciante}
                                        numberFormat={numberFormat}
                                        setIsReady={setIsReady}
                                        dispatch={dispatch}
                                        setVisibleModal={setVisibleModal}
                                        setServices={setServices}
                                        setAffiliation={setAffiliation}
                                    />
                                )
                        }
                    </div>

                    {
                        configuraciones?.video?.visible && (
                            <Grid item xs={12}>
                                <div className={` ${classes.responsiveContentVideo}`} id='container'>
                                    <iframe className={classes.iframe} id='iframe' src={configuraciones?.video?.url} title='video' frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                </div>
                            </Grid>
                        )
                    }

                    {
                        configuraciones?.listas?.map((lista, key) => (
                            <Alert key={key} variant="filled" severity={lista?.tipo == 1 ? 'success' : 'info'} style={{ textAlign: 'justify', fontSize: 13, fontWeight: 'normal', marginLeft: 10, marginRight: 10, marginBottom: 10, borderRadius: 6 }}>
                                {lista?.titulo}
                                {
                                    lista?.items && (
                                        <ol>
                                            {
                                                lista?.items.map((item, k) => (
                                                    <li key={k}>{item}</li>
                                                ))
                                            }
                                        </ol>
                                    )
                                }
                                {lista?.pie}
                            </Alert>
                        ))
                    }
                </Grid>
            </Grid>
        
            <div style={{ background: '#fff', width: '100%', textAlign: 'center'}}> 
                <p style={{ fontFamily: 'Roboto', color: 'grey', fontSize: 12 }}>Powered by Cámara de Comercio de Cartago {new Date().getFullYear()} - v1.1.0</p>
            </div>

            <Modal
                state={state}
                dispatch={dispatch}
                visible={visibleModal}
                setVisible={setVisibleModal}
                numberFormat={numberFormat}
                services={services}
                affiliation={affiliation}
                setAffiliation={setAffiliation}
            />

            <Snackbar open={snackbar.visible} autoHideDuration={6000} onClose={() => setSnackbar(e => ({...e, visible: false}))} style={{ width: '100%' }}>
                <Alert severity="error" variant='filled' style={{ width: '100%', marginLeft: 10, marginRight: 10 }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    responsiveContentVideo: {
        background: '#000',
        height: 650,
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 10,
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'center'
    },
    iframe: {
        width: '70%',
        height: '100%'
    },
    containerForm: {
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 10,
        borderRadius: 6,
        display: 'flex',  
        justifyContent: 'center',
        alignItems: 'center',
        height: 500
    }
}));

export default Main;